import { render, staticRenderFns } from "./GridCompetenciesCrud.vue?vue&type=template&id=2ef3ab5f&scoped=true"
import script from "./GridCompetenciesCrud.vue?vue&type=script&lang=js"
export * from "./GridCompetenciesCrud.vue?vue&type=script&lang=js"
import style0 from "./GridCompetenciesCrud.vue?vue&type=style&index=0&id=2ef3ab5f&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2ef3ab5f",
  null
  
)

export default component.exports